// extracted by mini-css-extract-plugin
module.exports = {"signup-mgm__download":"BannerDownloadApp_signup-mgm__download__PzDhN","text":"BannerDownloadApp_text__BxNQT","button":"BannerDownloadApp_button__MHY_6"};